export const NUMBER_IN_HOUSEHOLD_OPTIONS = [
  { value: '1' },
  { value: '2' },
  { value: '3' },
  { value: '4' },
  { value: '5' },
];
